var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('SideBar',{attrs:{"menuToggler":_vm.menuToggler},on:{"closeMenu":_vm.closeMenu}}),_c('div',{staticClass:"content",attrs:{"id":"content"}},[_c('div',{staticClass:"menu-opener",on:{"click":_vm.toggleMenu}},[_c('div'),_c('div'),_c('div')]),_c('TopBar'),_c('Breadcrumb'),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }